import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

const FeatureSectionStyled = styled('section')(({ theme }) => ({
    padding: theme.spacing(8, 2),
    backgroundColor: '#fff',
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(12, 4),
    },
}));

const FeatureCard = styled(Card)(({ theme }) => ({
    height: '100%',
    boxShadow: 'none',
    border: '1px solid rgba(0,0,0,0.08)',
    borderRadius: '16px',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
        transform: 'translateY(-8px)',
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
    },
}));

const features = [
    {
        title: 'Easy Access',
        description: 'Find and book appointments with qualified healthcare providers in your area quickly and easily.',
    },
    {
        title: 'Quality Care',
        description: 'Access top-rated healthcare professionals and specialists for comprehensive medical care.',
    },
    {
        title: 'Affordable Options',
        description: 'Compare prices and find the most cost-effective healthcare solutions that meet your needs.',
    },
];

const FeatureSection = () => {
    return (
        <FeatureSectionStyled>
            <Box sx={{ maxWidth: '1400px', margin: '0 auto' }}>
                <Box sx={{ textAlign: 'center', mb: 8 }}>
                    <Typography 
                        variant="h3" 
                        gutterBottom 
                        sx={{ 
                            fontWeight: 700,
                            mb: 2 
                        }}
                    >
                        Healthcare Made Simple
                    </Typography>
                    <Typography 
                        variant="h6" 
                        sx={{ 
                            color: 'text.secondary',
                            maxWidth: '600px',
                            margin: '0 auto'
                        }}
                    >
                        Experience healthcare that puts you first with our comprehensive platform
                    </Typography>
                </Box>
                
                <Grid container spacing={4}>
                    {features.map((feature, index) => (
                        <Grid item xs={12} md={4} key={index}>
                            <FeatureCard>
                                <CardContent sx={{ p: 4 }}>
                                    <Typography 
                                        variant="h5" 
                                        gutterBottom 
                                        sx={{ 
                                            fontWeight: 600,
                                            mb: 2
                                        }}
                                    >
                                        {feature.title}
                                    </Typography>
                                    <Typography 
                                        variant="body1" 
                                        sx={{ 
                                            color: 'text.secondary',
                                            lineHeight: 1.7
                                        }}
                                    >
                                        {feature.description}
                                    </Typography>
                                </CardContent>
                            </FeatureCard>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </FeatureSectionStyled>
    );
};

export default FeatureSection;
